export default () => {
    const hamburger = document.querySelector(".hamburger");
    const mobileMenu = document.querySelector(".header__mobile-menu");
  
    const toggleMobileMenu = () => {
      hamburger.classList.toggle("is-active");
      mobileMenu.classList.toggle("is-active");
      if (mobileMenu.classList.contains("is-active")) {
        mobileMenu.classList.remove("fadeOutSlide");
        mobileMenu.classList.add("fadeInSlide");
      } else {
        mobileMenu.classList.remove("fadeInSlide");
        mobileMenu.classList.add("fadeOutSlide");
        // Remove "fadeOut" class after 2 seconds
        setTimeout(() => {
          mobileMenu.classList.remove("fadeOutSlide");
        }, 1000);
      }
    };
  
    if (hamburger) {
      hamburger.addEventListener("click", toggleMobileMenu);
    }
  };